import React, {
  useCallback,
  useMemo,
} from 'react';
import { Col, Row } from 'antd';
import PropTypes from 'prop-types';
import OnTraccrCheckbox from '../common/inputs/OnTraccrCheckbox';

const columns = [
  'Title',
  'Assigned User',
  'Status',
  'Priority',
  'Due Date',
];

export default function DashboardTaskWidetsConfig({
  settings = {},
  onSave,
}) {
  const {
    visibleColumns = columns,
  } = settings;

  const visibleColumnSet = useMemo(() => new Set(visibleColumns), [visibleColumns]);

  const onChange = useCallback((columnKey) => (checked) => {
    const newChecked = [...visibleColumns];
    if (checked) {
      newChecked.push(columnKey);
    } else {
      const index = newChecked.indexOf(columnKey);
      if (index > -1) newChecked.splice(index, 1);
    }

    onSave({
      ...settings,
      visibleColumns: newChecked,
    });
  }, [settings, onSave]);

  return (
    <>
      <h4>Visible Columns</h4>
      <Row>
        {columns.map((column) => (
          <Col span={8} key={column} style={{ padding: '5px 0' }}>
            <OnTraccrCheckbox
              value={visibleColumnSet.has(column)}
              label={column}
              onChange={onChange(column)}
            />
          </Col>
        ))}
      </Row>
    </>
  );
}

DashboardTaskWidetsConfig.propTypes = {
  settings: PropTypes.shape({
    visibleColumns: PropTypes.array,
  }),
  onSave: PropTypes.func,
};

DashboardTaskWidetsConfig.defaultProps = {
  onSave: () => {},
  settings: { visibleColumns: columns },
};
